import {FilesViewerData, FileTypeName} from "../../../../types/file.types";

export const documentsGenerateButtons: Array<FilesViewerData> = [
  {
    title: 'Договор',
    key: 'CONTRACT'
  },
  {
    title: 'Акт',
    key: 'ACT'
  },
  {
    title: 'Тех. задание',
    key: 'TASK'
  }
];

export const generateFileIdKeys: Array<FileTypeName> = [
  'CONTRACT', 'ACT', 'TASK'
];
